import Vue from "vue";
import VueRouter from "vue-router";
import { Message } from "element-ui";
import vuex from "@/store/index";

//
import LayoutView from "@/views/LayoutView.vue";
import AdminView from "@/views/back/AdminView.vue";
import RegionView from "@/views/back/RegionView.vue";
import StaticView from "@/views/back/StaticView.vue";
import ModelView from "@/views/back/ModelView.vue";
import OCRDesensitizationView from "@/views/back/OCRDesensitizationView";
import ModelCueWordView from "@/views/back/ModelCueWordView";
import IntelligentWizardView from "@/views/back/IntelligentWizardView";
import InfluenceFactorView from "@/views/back/InfluenceFactorView";
import TestingInstrumentsView from "@/views/back/TestingInstrumentsView";
import AdminLoginView from "@/views/AdminLoginView.vue";
import AdminUserInfoView from "@/views/back/AdminUserInfoView.vue";
import report_type from "@/components/search/report_type";
import anomaly_index from "@/components/search/anomaly_index";
import disease_factors from "@/components/search/disease_factors";
import disease_number from "@/components/search/disease_number";
import UpdateNoticeView from "@/views/back/UpdateNoticeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
  },
  { path: "/admin/login", name: "AdminLogin", component: AdminLoginView },
  {
    path: "/layout",
    name: "L",
    component: () => import("../views/FrontView.vue"),
    redirect: "/report",
    children: [
      {
        path: "/report",
        name: "report",
        component: () => import("../views/pages/ReportView.vue"),
        meta: { index: 2 },
      },
      {
        path: "/other",
        name: "other",
        component: () => import("../views/pages/OtherView.vue"),
        meta: { index: 1 },
      },
      {
        path: "/analyse",
        name: "analyse",
        component: () => import("../views/pages/AnalyseView.vue"),
        meta: { index: 3 },
      },
      {
        path: "/back",
        name: "back",
        component: () => import("../views/pages/BackView.vue"),
      },
      {
        path: "/info",
        name: "info",
        component: () => import("../views/pages/UserInfoView.vue"),
      },
      {
        path:"/sys_notice",
        name: "sys_notice",
        component: () => import("../views/pages/SysNoticeView.vue"),
      },
    ],
  },
  {
    path: "/free",
    name: "free",
    component: () => import("../views/FreeView.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/pages/AboutView.vue"),
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("../views/PrivacyView.vue"),
  },
  {
    path: "/agreement",
    name: "agreement",
    component: () => import("../views/AgreementView.vue"),
  },
  {
    path: "/bec",
    name: "layout",
    component: LayoutView,
    redirect: "/bec/static",
    beforeEnter(to, from, next) {
      const userinfo = JSON.parse(localStorage.getItem("userinfo"));
      if (userinfo.is_superuser) {
        next();
        return;
      }
      Message({
        message: "当前用户没有权限",
        type: "warning",
        duration: 2000,
      });
      next({ name: "report" });
    },
    children: [
      { path: "admin", name: "admin", component: AdminView },
      { path: "region", name: "region", component: RegionView },
      { path: "model", name: "model", component: ModelView },
      { path: "static", 
        name: "static", 
        component: StaticView,
        meta: {
          keepAlive: true // 标识该路由需要被缓存
        },
      },
      {
        path: "desensitization",
        name: "OCRDesensitization",
        component: OCRDesensitizationView,
      },
      { path: "cue/word", name: "ModelCueWord", component: ModelCueWordView },
      {
        path: "intelligent/wizard",
        name: "IntelligentWizard",
        component: IntelligentWizardView,
      },
      {
        path: "influence/factor",
        name: "InfluenceFactor",
        component: InfluenceFactorView,
      },
      {
        path: "testing/instruments",
        name: "TestingInstruments",
        component: TestingInstrumentsView,
      },
      {
        path: "update_notice",
        name: "UpdateNoticeView",
        component: UpdateNoticeView,
      },
      {
        path: "disease",
        name: "disease",
        component: () => import("@/views/back/DiseaseView.vue"),
      },
      {
        path: "influence/dictionary",
        name: "influence_dictionary",
        component: () => import("@/views/back/InfluenceDictionaryView.vue"),
      },
      {
        path: "testing/dictionary",
        name: "testing_dictionary",
        component: () => import("@/views/back/TestingDictionaryView.vue"),
      },
      {
        path: "user/info",
        name: "AdminUserInfo",
        component: AdminUserInfoView,
      },
      {path: 'anomaly/index', name: 'anomaly_index', component: anomaly_index, props: true},
      {path: 'disease/factors', name: 'disease_factors', component: disease_factors, props: true},
      {path: 'disease/number', name: 'disease_number', component: disease_number, props: true},
      {path: 'report/type', name: 'report_type', component: report_type, props: true},
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// 路由守卫
router.beforeEach((to, from, next) => {
  const userinfo = localStorage.getItem("userinfo") || null;

  if (to.path === "/") {
    next("/login");
    return;
  }

  if (to.path === "/privacy") {
    next();
    return;
  }

  if (to.path === "/agreement") {
    next();
    return;
  }

  if (to.path === "/admin/login") {
    next();
    return;
  }

  if (to.path === "/login") {
    next();
    return;
  }

  if (!userinfo) {
    next("/login");
    Message({
      message: "请先登录",
      type: "warning",
      duration: 2000,
    });
    return;
  }

  next();
});

export default router;
